module.exports = __webpack_public_path__ + "static/media/icon_box_black.cc491fad.svg";